import dayjs from 'dayjs'
import numeral from 'numeral'
import { check_privilege, getPackageType } from '@/privileges.js'
import XLSX from 'xlsx'
import _ from 'lodash'

export default {
  methods: {
    isiPad() {
      return (
        ['iPad Simulator', 'iPad'].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
      )
    },
    detectMob() {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ]

      return toMatch.some(toMatchItem => {
        return navigator.userAgent.match(toMatchItem)
      })
    },
    check_privilege(name, options = {}) {
      let bot
      if (options.bot) {
        bot = options.bot
      } else if (this.$store.state.selectedBot) {
        bot = this.$store.state.selectedBot
      }

      return check_privilege(name, {
        ...options,
        bot: bot
      })
    },
    getPackageConfig(bot) {
      let packages = this.getPackageDetail()
      let account_packages = this.getPackageType(bot)
      let config = null
      if (account_packages.includes('enterprise')) {
        config = packages.enterprise
      } else if (account_packages.includes('business')) {
        config = packages.business
      } else if (account_packages.includes('advanced')) {
        config = packages.advanced
      } else if (account_packages.includes('premium')) {
        config = packages.premium
      } else if (account_packages.includes('old_premium')) {
        config = packages.old_premium
      } else {
        config = packages.basic
      }
      if (
        account_packages.includes('enterprise') ||
        account_packages.includes('advanced') ||
        account_packages.includes('premium') ||
        account_packages.includes('old_premium')
      ) {
        if (['277838862241623', '366319550102632'].includes(this.$store.state.selectedBot.pageid)) {
          config.inbox = 500
          config.reply_comment = 500
        }
        if (
          ['176922345693076', '314200052001768 '].includes(this.$store.state.selectedBot.pageid)
        ) {
          config.inbox = 500
        }
        if (this.$store.state.selectedBot.pageid == '164274239048484') {
          config.couponQuantity = 300
        }

        if (['307967852725125', '361231620965547'].includes(this.$store.state.selectedBot.pageid)) {
          config.inbox = 700
          config.reply_comment = 700
        }

        if (['183975518299717'].includes(this.$store.state.selectedBot.pageid)) {
          config.inbox = 700
        }
      }
      return config
    },
    getPackageDetail() {
      return {
        basic: {
          price: 0,
          reply_comment: 2,
          inbox: 10,
          products: 5,
          bubbles: 2,
          imageMap: false,
          coupon: false,
          couponQuantity: 10,
          salePage: false,
          wholeSale: false,
          salesReport: false,
          cartSummary: false,
          salepageAnalytics: false,
          chatGpt: false,
          verifySlip: 10,
          adsSimulator: 10
        },
        old_premium: {
          price: 500,
          reply_comment: 300,
          inbox: 300,
          products: 1000,
          bubbles: 10,
          imageMap: false,
          coupon: true,
          couponQuantity: 20,
          salePage: true,
          wholeSale: true,
          salesReport: true,
          cartSummary: true,
          salepageAnalytics: false,
          chatGpt: false,
          verifySlip: 3,
          adsSimulator: 100
        },
        premium: {
          price: 500,
          reply_comment: 100,
          inbox: 100,
          products: 500,
          bubbles: 10,
          imageMap: false,
          coupon: true,
          couponQuantity: 20,
          salePage: true,
          wholeSale: true,
          salesReport: true,
          cartSummary: true,
          salepageAnalytics: false,
          chatGpt: false,
          verifySlip: 3,
          adsSimulator: 100
        },
        advanced: {
          price: 1200,
          reply_comment: 300,
          inbox: 300,
          products: 3000,
          bubbles: 10,
          imageMap: true,
          coupon: true,
          couponQuantity: 50,
          salePage: true,
          wholeSale: true,
          salesReport: true,
          cartSummary: true,
          salepageAnalytics: true,
          chatGpt: true,
          verifySlip: 10,
          adsSimulator: 300
        },
        enterprise: {
          price: 0,
          reply_comment: 999,
          inbox: 999,
          products: 3000,
          bubbles: 10,
          imageMap: false,
          coupon: true,
          couponQuantity: 10,
          salePage: false,
          wholeSale: true,
          salesReport: true,
          cartSummary: true,
          salepageAnalytics: true,
          chatGpt: true,
          verifySlip: 10,
          adsSimulator: 999
        },
        business: {
          price: 1200,
          reply_comment: 500,
          inbox: 500,
          products: 3000,
          bubbles: 10,
          imageMap: true,
          coupon: true,
          couponQuantity: 50,
          salePage: true,
          wholeSale: true,
          salesReport: true,
          cartSummary: true,
          salepageAnalytics: true,
          chatGpt: true,
          verifySlip: 10,
          adsSimulator: 500
        }
      }
    },
    getPackageType(bot) {
      if (!bot) {
        bot = this.$store.state.selectedBot
      }

      return getPackageType(bot)
    },
    getState(data) {
      var state = null

      try {
        if (data.state && data.state.match(/{(.*)}/)[0]) {
          state = data.state.match(/{(.*)}/)[0]
          state = state.slice(0, -1)
          state = state.slice(1, state.length)
          state = state.split(',')
          state = state
            .map(el => {
              return el.split('=')
            })
            .reduce((prev, curr) => {
              if (curr.length == 2) {
                prev[curr[0]] = curr[1]
              }
              return prev
            }, {})
        }
      } catch (error) {}
      return state
    },
    intentTemplate() {
      return {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: '',
        fb_val: '',
        line_val: '',
        ig_val: '',
        fb_quick_reply: '',
        line_quick_reply: '',
        ig_quick_reply: '',
        context_in: '',
        context_out: '',
        postidlist: '',
        userstatus: '',
        usertags: '',
        isShow: false,
        userstatus: null,
        usertags: null,
        linenoti_status: false,
        linenoti_spec_ids: null,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true,
        not_reply_within_seconds: null,
        not_reply_within_times: null,
        frequency_per_day: null
      }
    },
    formatAnswer(a_val, a_type) {
      var vm = this
      if (vm.isCommentToInbox || vm.isLiveStream) {
        if (vm.isJsonParseable(a_val)) {
          return JSON.parse(a_val)
        } else {
          return [
            [
              {
                type: 'text',
                text: a_val
              }
            ]
          ]
        }
      } else if (a_val == '{welcome_message}') {
        return [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
      } else if (a_type == 'json') {
        try {
          return JSON.parse(a_val)
        } catch (error) {
          // console.log(a_val)
        }
      } else if (a_val != '' && a_type == 'text') {
        var newGroup = []
        var group_messages = a_val.split('||')
        $.each(group_messages, function(index, group) {
          var messages = group.split('#nl')
          var newMessages = []
          $.each(messages, function(inedx, message) {
            if (vm.isURL(message)) {
              newMessages.push({
                type: 'image',
                value: message
              })
            } else if (!isNaN(message)) {
              newMessages.push({
                type: 'text',
                value: {
                  text: message,
                  buttons: []
                }
              })
            } else if (vm.isJsonParseable(message)) {
              newMessages.push({
                type: 'text',
                value: JSON.parse(message)
              })
            } else {
              newMessages.push({
                type: 'text',
                value: {
                  text: message,
                  buttons: []
                }
              })
            }
          })
          newGroup.push(newMessages)
        })

        return newGroup
      } else if (a_type == 'template') {
        if (vm.isJsonParseable(a_val)) {
          return JSON.parse(a_val)
        } else {
          return []
        }
      } else if (a_type == 'message') {
        return [
          [
            {
              type: 'text',
              text: a_val
            }
          ]
        ]
      } else if (a_type == 'none') {
        return [[]]
      } else if (a_type == 'viewsummary') {
        return [
          [
            {
              type: 'text',
              text: '{viewsummary}'
            }
          ]
        ]
      }
    },
    noSpaceAndSpecial(event, noTrim) {
      var val

      if (event.target) {
        val = event.target.value
      } else {
        val = event
      }

      try {
        if (!noTrim) {
          val = val.trim()
        }
        return val
          .replace(/[$^,|<>]/g, '')
          .replace(/(‘|’)/gim, '')
          .replace(/(“|”)/gim, '')
          .replace(/​/gim, '')
          .replace(/ /gim, '')
      } catch (error) {
        return ''
      }
    },
    numberOnly(event) {
      var val = event.target.value.trim()
      return val.replace(/\D/g, '')
    },
    decimalOnly(event) {
      var val = event.target.value.trim()
      return numeral(val).value()
    },
    wait(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    isSupportLanguage: function(message, ispremium) {
      if (ispremium) return true
      else {
        let result =
          message.search(
            /[ก-๛a-zA-Z0-9\~\$\&\+\,\:\;\=\?\@\#\|\'\"\<\>\.\^\*\(\)\%\!\-\/\[\]\\\_\{\}\s\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff]/gim
          ) === -1
        return !result
      }
    },
    isURL: function(str) {
      var pattern = new RegExp(
        /^(ftp|http|https|line):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
      ) // fragment locator
      return pattern.test(str)
    },
    isImageURL: function(str) {
      var pattern = new RegExp(/(http(s?):)([/|.|\w|\s|-])*\.(?:jpg|gif|png)/g) // fragment locator
      return pattern.test(str)
    },
    isCheckOtherLanguge: function(str) {
      var pattern = new RegExp(
        /[^ก-๛a-zA-Z0-9\~\$\&\+\,\:\;\=\?\@\#\|\'\"\<\>\.\^\*\(\)\%\!\-\/\[\]\\\_\{\}\s\u00a9\u00ae\u2000-\u3300\ud83c\ud000-\udfff\ud83d\ud000-\udfff\ud83e\ud000-\udfff]/gim
      )
      return pattern.test(str)
    },
    isJsonParseable: function(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    },
    isNumber: function(str) {
      try {
        parseFloat(str)
      } catch (e) {
        return false
      }
      return true
    },
    exportCsv: function(csvContent, name) {
      var csvData = new Blob(['\uFEFF' + csvContent], { type: 'text/csv; charset=utf-18' }) // new way
      var csvUrl = URL.createObjectURL(csvData)

      var link = document.createElement('a')
      link.setAttribute(
        'style',
        'overflow: hidden;position: fixed;width: 1px;height: 1px;z-index: -1;opacity: 0;'
      )
      link.setAttribute('href', csvUrl)
      link.setAttribute('download', dayjs().format('YYYY_MM_DD') + '_' + name + '.csv')
      link.innerHTML = 'Click Here to download'
      document.body.appendChild(link) // Required for FF

      link.click()
    },
    exportText: function(csvContent, name) {
      var csvData = new Blob(['\uFEFF' + csvContent], { type: 'text/plain; charset=utf-18' }) // new way
      var csvUrl = URL.createObjectURL(csvData)

      var link = document.createElement('a')
      link.setAttribute(
        'style',
        'overflow: hidden;position: fixed;width: 1px;height: 1px;z-index: -1;opacity: 0;'
      )
      link.setAttribute('href', csvUrl)
      link.setAttribute('download', name + '.txt')
      link.innerHTML = 'Click Here to download'
      document.body.appendChild(link) // Required for FF

      link.click()
    },
    setLang: function(lang) {
      this.$store.dispatch('setLang', lang)
    },
    checkEmptyReplyMessage(messages) {
      return messages
        .map(function(m) {
          if (
            (m[0].replyinbox === true &&
              m[0].responseinbox[0].text !== '' &&
              m[0].responseinbox[0].text !== null) ||
            (m[0].replycomment === true &&
              m[0].responsecomment[0].text !== '' &&
              m[0].responsecomment[0].text !== null) ||
            m[0].hidecomment === true ||
            m[0].is_like_comment === true
          ) {
            if (m[0].replyinbox === true && m[0].responseinbox[0].type === 'generic') {
              m[0].responseinbox[0].data = m[0].responseinbox[0].data.filter(v => {
                return v.image_url || v.title || v.subtitle
              })
            }
            return m
          } else {
            return null
          }
        })
        .filter(el => {
          return el != null
        })
    },
    checkEmptyMessage(messages) {
      var result = messages
        .map(message => {
          return message
            .map(msg => {
              if (msg.type === 'text') {
                if (msg.text !== '' && msg.text != null) {
                  return msg
                }
              } else if (msg.type === 'button') {
                if ((msg.text !== '' && msg.text != null) || msg.buttons.length > 0) {
                  return msg
                }
              } else if (msg.type === 'image') {
                if (msg.image_url) {
                  return msg
                } else {
                  return null
                }
              } else if (msg.type === 'generic') {
                var generics = msg.data.filter((generic, gindex) => {
                  return (
                    generic.image_url != null ||
                    generic.title !== '' ||
                    generic.subtitle !== '' ||
                    (typeof generic.productid != 'undefined' && generic.productid != null) ||
                    generic.buttons.length > 0
                  )
                })

                if (generics.length > 0) {
                  return {
                    custom_type: msg.custom_type === 'catalogue' ? 'catalogue' : null,
                    type: 'generic',
                    data: generics,
                    ratio: msg.ratio == 'horizontal' ? 'horizontal' : 'square',
                    altText: msg.altText ? msg.altText : 'You received a message'
                  }
                } else {
                  return null
                }
              } else if (msg.type === 'flex') {
                if (msg.contents !== '' && msg.contents != null) {
                  return msg
                } else {
                  return null
                }
              } else {
                return msg
              }
            })
            .filter(el => {
              return el != null
            })
        })
        .filter(message => {
          return message.length > 0
        })

      if (result.length === 0) {
        result = [[]]
      }

      return result
    },
    isNumber(value) {
      return typeof value === 'number' && isFinite(value)
    },
    roundNumber(val, pow = 2) {
      return Math.round(val * Math.pow(10, pow)) / Math.pow(10, pow)
    },
    formatTime(time, props) {
      props = props || {}
      props.defaultHour = props.defaultHour || '00'
      props.defaultMinius = props.defaultMinius || '00'
      if (time) {
        return (time['HH'] || props.defaultHour) + ':' + (time['mm'] || props.defaultMinius)
      }
      return `${props.defaultHour}:${props.defaultMinius}`
    },
    log() {
      if (this.$store.state.debug && process.env.NODE_ENV === 'development') {
        console.log(...arguments)
      }
    },
    async exportOrderData(orders, filterCategoryStatus) {
      let vm = this
      let order = []
      let filename = ''
      var json = []

      order = orders.filter(val => {
        if (filterCategoryStatus == 'all') return true
        else return val.livename == filterCategoryStatus
      })
      // csvContent +=
      //   'Order No.,Status,SKU,Products,Price,Remark,Social Name,Real Name,Address,Price,Shipping,Tracking No.,Created Date,Status,Tags,Quantity' +
      //   '\r\n'
      // order = orders.sort(
      //   (a, b) =>
      //     dayjs(b.timestamp).format('YYYYMMDDHHmm') - dayjs(a.timestamp).format('YYYYMMDDHHmm')
      // )
      order.forEach(val => {
        var productdetail = []
        try {
          var products = JSON.parse(val.productdetail)
        } catch (error) {
          var products = val.productdetail
        }
        // console.log('product', typeof products, products)
        try {
          if (typeof products == 'object' && products.length > 0) {
            products.map(function(product) {
              productdetail.push({
                name: product.name ? product.name : '',
                quantity: product.quantity,
                sku: product.sku ? product.sku : '',
                option: product.option ? ' (' + product.option + ')' : '',
                price: product.price > 0 ? product.price : 'Free',
                cart_remark: product.cart_remark
              })
            })
          } else {
            productdetail[0] = val.productdetail
          }
        } catch (error) {
          productdetail[0] = val.productdetail
        }

        // console.log(typeof productdetail, productdetail)

        var realname = val.nameaddress.split(' , ')
        let telephone = '',
          receiver_name = '',
          address = ''
        if (realname.length > 0) {
          if (realname.length > 1) {
            receiver_name = realname[0]
            realname.splice(0, 1)
          }

          let telephone_index = realname.findIndex(el => {
            return el.match(/^[0][0-9]{8,9}$/g)
          })

          if (telephone_index != -1) {
            telephone = realname[telephone_index]
            realname.splice(telephone_index, 1)
          }

          address = realname.join(',')
        }
        address = address || val.nameaddress
        var shippingType = ''

        var jsondata = val.shippingtype

        var couponcode = ''
        let transactionid = val.transactionid ? val.transactionid : ''
        try {
          jsondata = JSON.parse(val.jsonvalue)
          couponcode = jsondata.promocode ? jsondata.promocode : ''
        } catch (error) {}

        let tax_detail = null
        try {
          tax_detail = JSON.parse(val.address_json)
        } catch (error) {}

        var row = {
          'Date & Time': dayjs(val.timestamp).format('DD/MM/YYYY HH:mm'),
          'Order Number': val.id,
          'Status Order': val.status,
          'Total per Order': val.allquantity ? `${val.allquantity}` : '-',
          SKU: typeof productdetail[0] == 'string' ? products[0].sku : productdetail[0].sku,
          Products:
            typeof productdetail[0] == 'string'
              ? productdetail[0]
              : `${productdetail[0].name}${
                  productdetail[0].option ? ` ${productdetail[0].option}` : ''
                }`,
          'SKU Amount':
            typeof productdetail[0] == 'string' ? productdetail[0].quantity : products[0].quantity,
          Price:
            typeof productdetail[0] == 'string'
              ? ''
              : numeral(productdetail[0].price).format('0,0.00'),
          'Shipping fee': numeral(val.shippingcharge)
            .format('0,0.00')
            .toString(),
          Discount: numeral(val.discount)
            .format('0,0.00')
            .toString(),
          Total: numeral(val.amount)
            .format('0,0.00')
            .toString(),
          Shipping: shippingType ? vm.$t(shippingType) : '',
          'Tracking No.': val.trackingno,
          'Transaction ID': transactionid,
          'Shippop Tracking No.': vm.selectedBot.shippop_status ? val.shippop_tracking_code : '-',
          Remark: val.remark != null ? val.remark : '',
          Channel: val.app,
          'Social Name': val.first_name + ' ' + val.last_name,
          'Real Name': receiver_name,
          'Tel.': telephone,
          Address: address,
          'Full Address': val.nameaddress,
          Status:
            vm.$store.getters.getPackage == 'premium' && val.userstatus ? val.userstatus : '-',
          'Customer Tags': vm.$store.getters.getPackage == 'premium' && val.tags ? val.tags : '-',
          'Cutomer Code': couponcode,
          'Tax ID': tax_detail ? tax_detail.tax_id : '',
          'Tax Address': tax_detail ? tax_detail.tax_address : '',
          'Issue Date': tax_detail ? dayjs(tax_detail.invoice_date).format('DD/MM/YYYY HH:mm') : ''
        }

        try {
          let split_address = address.split(',')
          split_address.forEach((val, index) => (row['Address ' + (index + 1)] = val))
        } catch (error) {}

        json.push(row)

        if (productdetail.length > 1) {
          productdetail.map((detail, dindex) => {
            if (dindex != 0) {
              json.push({
                SKU: detail.sku,
                Products: `${detail.name}${detail.option ? ` ${detail.option}` : ''}`,
                Price: numeral(detail.price).format('0,0.00'),
                'SKU Amount': detail.quantity
              })
            }
          })
        }
      })
      filename = 'zwizshop'
      var dataWS = null
      dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
    },
    allowBetaFeature(feature) {
      const pageId = this.selectedBot.pageid
      const allowPageIds = new Set()

      if (feature === 'product_cost') {
        allowPageIds.add('361231620965547') // Zwiz.AI แชทบอท
        allowPageIds.add('844584862409516') // My Shop Demo
        allowPageIds.add('115013341582884') // ZwizWin
        allowPageIds.add('106068242422898') // JiHyun
      }

      return new Set(allowPageIds).has(pageId)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/mainMixin.js